import { render, staticRenderFns } from "./TargetingPropertiesData.vue?vue&type=template&id=14b29a11&scoped=true"
import script from "./TargetingPropertiesData.vue?vue&type=script&lang=js"
export * from "./TargetingPropertiesData.vue?vue&type=script&lang=js"
import style0 from "./TargetingPropertiesData.vue?vue&type=style&index=0&id=14b29a11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b29a11",
  null
  
)

export default component.exports